import { createTheme } from '@mui/material/styles';

// Create a custom theme that uses local Roboto fonts (defined in styles/index.scss)
// and explicitly disables Google Fonts loading
export const theme = createTheme({
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    body1: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    body2: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    button: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    caption: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h1: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h2: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h3: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h4: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h5: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h6: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    subtitle1: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    subtitle2: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    overline: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
  },
  // Prevent Material-UI from loading its own fonts
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Empty styleOverrides prevents MuiCssBaseline from loading Google Fonts
        // Our local @font-face declarations in styles/index.scss take precedence
      },
    },
  },
});
